import { APIClient, ApiQueryParams } from '@frontend/api-utils';
import { Token } from '@frontend/authentication-v2';
import { AllowanceQueryParams, BudgetAnalyzerProductAllowanceResponse } from '@frontend/budget/types';

export class BudgetAnalyzerClient extends APIClient {
    public static readonly endpoint = '/budget-api/v1';

    public static async analyzeAccountUserProductAllowance(
        accountId: string,
        userId: string,
        ids: string[],
        queryParams?: ApiQueryParams<AllowanceQueryParams>,
        withCredentials?: Token
    ): Promise<BudgetAnalyzerProductAllowanceResponse> {
        const response = await this.postWithQueryParams(
            `${this.endpoint}/accounts/${accountId}/users/${userId}/product-allowance`,
            queryParams,
            { ids },
            true,
            withCredentials
        );
        return await this.handleResponse<BudgetAnalyzerProductAllowanceResponse>(response);
    }
}
